<template>
  <div class="notification_area account_area d-grid">
    <div class="account_wrap">
      <div class="account_wrap-container">
        <div class="notification_title d-flex">
          <h5 v-if="!isWebView" class="account_title mb-0">
            {{ $t("Bao.notify_letter") }}
          </h5>
          <h5 v-else />
          <button class="btn btn_readmore" type="button" :disabled="actionLoading" @click="setAllRead">
            {{ $t("Bao.mark_all_read") }}
            <i v-show="actionLoading" class="fa fa-spinner fa-pulse fa-fw" />
          </button>
        </div>
        <div v-if="letter.length == 0 && !loading" class="notification_bar d-grid">
          <div class="text-center no-data-area">
            <img width="258" src="@/assets/images/no_record_data.png">
            <h5>{{ $t('Bao.no_relevant_data_records') }}</h5>
            <span>{{ $t('Bao.search_results_are_empty') }}</span>
          </div>
        </div>
        <ul v-else class="notification_list list-unstyled d-grid" :class="$store.getters.brand.theme">
          <li v-for="(item,index) in letter" :key="index">
            <div id="accordion_1" class="accordion">
              <div class="card border-0">
                <b-card-header header-tag="header" class="d-flex justify-content-between align-items-center" :aria-expanded="item.show" @click="toggleContent(item)">
                  <span>
                    <h5 :class="['notification_msg_title', 'mb-0', {'dot': item.status == 0 }]">{{ item.title }}</h5>
                    <h5 class="notification_msg_date mb-0">
                      {{ item.created_at | dateFormat }}
                    </h5>
                  </span>
                  <button class="btn btn_notification_click" type="button" :aria-expanded="item.show ? 'true' : 'false'" />
                </b-card-header>
                <b-collapse v-model="item.show" role="tabpanel">
                  <b-card-body>
                    <p class="mb-0 nl2br">
                      {{ item.content }}
                    </p>
                  </b-card-body>
                </b-collapse>
              </div>
            </div>
          </li>
        </ul>
        <scroll-loader :loader-method="query" :loader-disable="!enableAutoLoad" />
      </div>
    </div>
  </div>
</template>

<script>
import { getLetter, setLetterRead, setAllLetterRead } from '@/api/user'
import { showNotice } from '@/utils/tool'
import ScrollLoader from 'vue-scroll-loader/src/components/Scroll-Loader'
import { BCardHeader, BCardBody, BCollapse } from 'bootstrap-vue'

export default {
  components: {
    ScrollLoader,
    BCardHeader,
    BCardBody,
    BCollapse
  },
  data() {
    return {
      show: false,
      letter: [],
      page: 1,
      pageSize: 10,
      enableAutoLoad: false,
      loading: false,
      actionLoading: false
    }
  },
  computed: {
    newLetter() {
      return this.$store.state.user.newLetter
    },
    isWebView() {
      if (this.$route.path === '/web/user/letter') return true
      else return false
    }
  },
  watch: {
    newLetter() {
      this.oneQuery()
      this.$store.commit('SET_NEW_LETTER', false)
    }
  },
  created() {
    if (this.$store.state.user.newLetter) {
      this.$store.commit('SET_NEW_LETTER', false)
    }
    this.oneQuery()
  },
  methods: {
    async query() {
      if (this.loading) return
      this.loading = true
      const queryObj = {
        'page': this.page,
        'page_size': this.pageSize
      }
      getLetter(queryObj).then(response => {
        this.letter = [...this.letter, ...response.data.data.list]
        for (const i in this.letter) {
          if (i === 0) this.$set(this.letter[i], 'show', true)
          else this.$set(this.letter[i], 'show', false)
        }
        if (response.data.data.list.length < this.pageSize) {
          this.enableAutoLoad = false
        } else {
          this.page += 1
          this.enableAutoLoad = true
        }
        this.loading = false
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    oneQuery() {
      // this.enableAutoLoad = true
      this.page = 1
      this.letter = []
      this.query()
    },
    toggleContent(item) {
      if (item.show) {
        item.show = false
        return
      } else {
        if (parseInt(item.status) === 0) {
          this.setRead(item)
        }
      }
      for (const i in this.letter) {
        this.letter[i].show = false
      }
      item.show = true
    },
    setRead(item) {
      setLetterRead({ id: item.id }).then(response => {
        item.status = 1
        if (response.data.data.unread_letter_num === 0) {
          this.$store.commit('SET_UNREAD_LETTER', false)
        } else {
          this.$store.commit('SET_UNREAD_LETTER', response.data.data.unread_letter_num)
        }
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    setAllRead() {
      this.actionLoading = true
      setAllLetterRead().then(response => {
        for (const i in this.letter) {
          this.letter[i].status = 1
        }
        this.$store.commit('SET_UNREAD_LETTER', false)
        showNotice(response.data.msg)
      }).catch((error) => {
        showNotice(error.response.data.msg)
      }).finally((e) => {
        this.actionLoading = false
      })
    }
  }
}

</script>

<style>
.theme1 .dot:before {
  background: #31d9e3;
}
.theme1 .btn_notification_click:hover {
  border-color: #31d9e3 !important;
}
.theme2 .dot:before,
.theme4 .dot:before {
  background: #07b754;
}
.theme2 .btn_notification_click:hover {
  border-color: #9aeeaa !important;
}
.dot:before {
    content:"\A";
    width:8px;
    height:8px;
    border-radius:50%;
    display:inline-block;
    margin-bottom: 2px;
    margin-right: 8px;
}
</style>
